var _path, _path2, _g, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.192 0c-1.1.005-2.153.099-3.078.264-2.725.481-3.219 1.49-3.219 3.348v2.455h6.442v.817H4.478C2.606 6.884.967 8.01.455 10.15c-.591 2.455-.618 3.984 0 6.546.457 1.907 1.551 3.265 3.423 3.265h2.215v-2.94c0-2.127 1.84-4.001 4.023-4.001h6.434c1.79 0 3.221-1.474 3.221-3.274V3.612c0-1.744-1.472-3.056-3.221-3.348A20.14 20.14 0 0 0 13.192 0ZM9.71 1.976c.665 0 1.208.551 1.208 1.23 0 .677-.542 1.224-1.208 1.224A1.215 1.215 0 0 1 8.5 3.206c0-.679.54-1.23 1.209-1.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 21,
    height: 21,
    x: -1,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.769-.004H-.165v19.967H19.77V-.004Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h20.672v20.355H0z",
    transform: "matrix(1 0 0 -1 -.411 20.213)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 21,
    height: 22,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.573 6.884v2.86c0 2.218-1.88 4.085-4.023 4.085h-6.434c-1.762 0-3.221 1.508-3.221 3.274v6.133c0 1.744 1.518 2.773 3.221 3.274 2.04.6 3.995.707 6.434 0 1.621-.47 3.221-1.415 3.221-3.274v-2.454h-6.436v-.818H22.99c1.872 0 2.569-1.305 3.221-3.265.673-2.017.644-3.957 0-6.546-.463-1.863-1.347-3.265-3.221-3.265h-2.417v-.004Zm-3.619 15.532c.668 0 1.209.547 1.209 1.224 0 .68-.54 1.23-1.209 1.23a1.221 1.221 0 0 1-1.208-1.23c0-.677.542-1.224 1.208-1.224Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 21,
    height: 22,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.884 6.884H6.895v20.331h19.989V6.884Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M0 0h20.672v20.777H0z",
    transform: "matrix(1 0 0 -1 6.649 27.475)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "scale(.00505 .0051)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "scale(.00505)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,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",
    id: "h",
    width: 198,
    height: 196
  }), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,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",
    id: "i",
    width: 198,
    height: 198
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26.706v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.bdd431cce90c6bc470619eb05342f25f.svg";
export { ForwardRef as ReactComponent };